var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _circle, _path23, _path24, _circle2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _circle3, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _circle4, _path61, _path62, _path63, _circle5, _path64, _path65, _path66, _circle6, _path67, _path68, _path69, _path70, _path71, _circle7, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle8, _path89, _path90, _path91, _path92, _path93, _path94, _circle9, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _circle0, _path119, _circle1, _path120, _path121, _circle10, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _circle11, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _circle12, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _circle13, _circle14, _circle15, _path164, _path165, _path166, _path167, _circle16, _circle17, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPm25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,5.62c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,5.62c.3,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,5.62c.3,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,5.1s.01,0,.01-.01c0,0,0-.01-.01-.01,0,0-.01,0-.01.01,0,0,0,.01.01.01Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,5.61c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,5.4c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,5.16s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,7.71c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,7.31c.07,0,.13-.06.13-.13s-.06-.13-.13-.13-.13.06-.13.13.06.13.13.13Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,7.47c.16,0,.3-.13.3-.3s-.13-.3-.3-.3-.3.13-.3.3.13.3.3.3Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,7.71c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,7.24s.06-.03.06-.06-.03-.06-.06-.06-.06.03-.06.06.03.06.06.06Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,7.3c.07,0,.12-.05.12-.12s-.05-.12-.12-.12-.12.05-.12.12.05.12.12.12Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,7.2s.02,0,.02-.02c0,0,0-.02-.02-.02-.01,0-.02,0-.02.02,0,0,0,.02.02.02Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,7.33c.09,0,.16-.07.16-.16s-.07-.16-.16-.16-.16.07-.16.16.07.16.16.16Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,7.61c.24,0,.43-.19.43-.43s-.19-.44-.43-.44-.44.19-.44.44.19.43.44.43Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,7.27c.05,0,.09-.04.09-.09s-.04-.09-.09-.09-.09.04-.09.09.04.09.09.09Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,7.21s.03-.01.03-.03c0-.02-.01-.03-.03-.03s-.03.01-.03.03c0,.02.01.03.03.03Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,9.35s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,9.59c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,9.7c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,9.6c.18,0,.33-.14.33-.33s-.15-.33-.33-.33-.33.15-.33.33.15.33.33.33Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,9.99c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,10.08c.45,0,.81-.36.81-.81s-.36-.81-.81-.81-.81.36-.81.81.36.81.81.81Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.41,
    cy: 9.27,
    r: 0.55
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,9.82c.3,0,.55-.24.55-.55s-.24-.55-.55-.55-.55.24-.55.55.24.55.55.55Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,9.43c.09,0,.16-.07.16-.16s-.07-.16-.16-.16-.16.07-.16.16.07.16.16.16Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.69,
    cy: 9.27,
    r: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,9.98c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,9.36c.05,0,.09-.04.09-.09s-.04-.09-.09-.09-.09.04-.09.09.04.09.09.09Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,11.39s.03-.01.03-.03c0-.02-.01-.03-.03-.03s-.03.01-.03.03c0,.02.01.03.03.03Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,11.53c.09,0,.17-.08.17-.17s-.08-.17-.17-.17-.17.08-.17.17.08.17.17.17Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,11.78c.23,0,.41-.18.41-.41s-.18-.41-.41-.41-.41.18-.41.41.18.41.41.41Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,12c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,11.92c.3,0,.55-.25.55-.55s-.25-.55-.55-.55-.55.25-.55.55.25.55.55.55Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,11.81c.25,0,.45-.2.45-.45s-.2-.45-.45-.45-.45.2-.45.45.2.45.45.45Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,12.07c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,12.06c.38,0,.7-.31.7-.7s-.31-.7-.7-.7-.7.31-.7.7.31.7.7.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,11.92c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,12.05c.38,0,.69-.31.69-.68s-.31-.69-.69-.69-.68.31-.68.69.31.68.68.68Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,11.85c.27,0,.48-.22.48-.48s-.22-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,11.65c.16,0,.29-.13.29-.28s-.13-.29-.29-.29-.28.13-.28.29.13.28.28.28Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,11.41s.05-.02.05-.05-.02-.05-.05-.05-.05.02-.05.05.02.05.05.05Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,11.46c.05,0,.09-.04.09-.09s-.04-.09-.09-.09-.09.04-.09.09.04.09.09.09Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,13.55c.05,0,.09-.04.09-.09s-.04-.09-.09-.09-.09.04-.09.09.04.09.09.09Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,13.66c.11,0,.2-.09.2-.2s-.09-.2-.2-.2-.2.09-.2.2.09.2.2.2Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,13.78c.18,0,.33-.14.33-.33s-.15-.33-.33-.33-.32.15-.32.33.14.33.32.33Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,13.63c.1,0,.17-.08.17-.17s-.08-.17-.17-.17-.17.08-.17.17.08.17.17.17Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,13.84c.21,0,.38-.17.38-.38s-.17-.38-.38-.38-.38.17-.38.38.17.38.38.38Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,14.14c.37,0,.68-.3.68-.68s-.3-.68-.68-.68-.68.3-.68.68.3.68.68.68Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,14.16c.39,0,.7-.31.7-.7s-.31-.7-.7-.7-.7.31-.7.7.31.7.7.7Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,14.17c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14.09c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,14.03c.31,0,.57-.25.57-.57s-.26-.57-.57-.57-.57.25-.57.57.26.57.57.57Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,13.68c.12,0,.22-.1.22-.22s-.1-.22-.22-.22-.22.1-.22.22.1.22.22.22Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.78,
    cy: 13.46,
    r: 0.53
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,13.61c.08,0,.15-.07.15-.15s-.07-.15-.15-.15-.15.07-.15.15.07.15.15.15Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,14.17c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M35.06,13.54s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,15.81c.14,0,.26-.12.26-.26s-.12-.26-.26-.26-.26.12-.26.26.12.26.26.26Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,15.78c.12,0,.23-.1.23-.23s-.1-.23-.23-.23-.23.1-.23.23.1.23.23.23Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,16.08c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,15.78c.13,0,.23-.1.23-.23s-.1-.23-.23-.23-.23.11-.23.23.1.23.23.23Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,15.87c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,15.98c.24,0,.43-.19.43-.43s-.19-.43-.43-.43-.43.19-.43.43.19.43.43.43Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.31,
    cy: 15.55,
    r: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,16.11c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,16.02c.26,0,.46-.21.46-.46s-.21-.46-.46-.46-.46.21-.46.46.21.46.46.46Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,16.02c.26,0,.46-.21.46-.46s-.21-.46-.46-.46-.46.21-.46.46.21.46.46.46Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.69,
    cy: 15.55,
    r: 0.27
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,15.97c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,15.88c.18,0,.33-.15.33-.33s-.15-.33-.33-.33-.33.14-.33.33.14.33.33.33Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,15.96c.23,0,.41-.18.41-.41s-.18-.41-.41-.41-.41.18-.41.41.18.41.41.41Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.06,
    cy: 15.55,
    r: 0.32
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,18.28c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,18.27c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,18.06c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,17.9c.14,0,.25-.11.25-.26s-.11-.25-.25-.25-.26.11-.26.25.11.26.26.26Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,17.95c.17,0,.31-.14.31-.31s-.14-.31-.31-.31-.31.14-.31.31.14.31.31.31Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.22,
    cy: 17.65,
    r: 0.33
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,18.12c.26,0,.47-.21.47-.47s-.21-.47-.47-.47-.47.21-.47.47.21.47.47.47Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,18.13c.27,0,.48-.22.48-.48s-.22-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,18.28c.35,0,.64-.29.64-.64s-.29-.64-.64-.64-.64.29-.64.64.29.64.64.64Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,18.23c.32,0,.58-.26.58-.58s-.26-.58-.58-.58-.58.26-.58.58.26.58.58.58Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,18.17c.29,0,.52-.23.52-.52s-.23-.52-.52-.52-.52.23-.52.52.23.52.52.52Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,18.13c.27,0,.48-.22.48-.48s-.22-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,17.75c.05,0,.1-.04.1-.1s-.04-.1-.1-.1-.1.04-.1.1.04.1.1.1Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,17.8c.09,0,.16-.07.16-.16s-.07-.16-.16-.16-.16.07-.16.16.07.16.16.16Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M35.06,17.97c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M37.15,18.17c.29,0,.53-.24.53-.53s-.24-.53-.53-.53-.53.24-.53.53.24.53.53.53Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,20.45c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,20.02c.16,0,.28-.13.28-.28s-.13-.28-.28-.28-.28.13-.28.28.13.28.28.28Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,20.09c.19,0,.35-.15.35-.35s-.16-.35-.35-.35-.35.15-.35.35.16.35.35.35Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,20.47c.4,0,.73-.33.73-.73s-.33-.73-.73-.73-.73.33-.73.73.33.73.73.73Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,20.28c.3,0,.54-.24.54-.54s-.24-.54-.54-.54-.54.24-.54.54.24.54.54.54Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,20.32c.32,0,.58-.26.58-.58s-.26-.58-.58-.58-.58.26-.58.58.26.58.58.58Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,20.33c.33,0,.59-.27.59-.59s-.26-.59-.59-.59-.59.27-.59.59.26.59.59.59Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.41,
    cy: 19.74,
    r: 0.41
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,20.22c.27,0,.48-.22.48-.48s-.22-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,20.3c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,20.26c.29,0,.52-.23.52-.52s-.23-.52-.52-.52-.52.23-.52.52.23.52.52.52Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,20.31c.32,0,.58-.26.58-.58s-.26-.58-.58-.58-.57.26-.57.58.26.58.57.58Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,20.39c.36,0,.65-.29.65-.65s-.29-.65-.65-.65-.65.29-.65.65.29.65.65.65Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,19.8s.06-.03.06-.06-.03-.06-.06-.06-.06.03-.06.06.03.06.06.06Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.06,
    cy: 19.74,
    r: 0.16
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66,21.87s.04-.02.04-.04-.02-.04-.04-.04-.04.02-.04.04.02.04.04.04Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,22c.09,0,.17-.08.17-.17s-.08-.17-.17-.17-.17.08-.17.17.08.17.17.17Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,22.48c.36,0,.65-.29.65-.65s-.29-.65-.65-.65-.65.29-.65.65.29.65.65.65Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,22.47c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,22.3c.26,0,.46-.21.46-.46s-.21-.46-.46-.46-.46.21-.46.46.21.46.46.46Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,22.4c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,22.32c.27,0,.48-.22.48-.48s-.22-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,22.25c.23,0,.41-.18.41-.41s-.18-.41-.41-.41-.41.18-.41.41.18.41.41.41Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,22.37c.3,0,.54-.24.54-.54s-.24-.54-.54-.54-.54.24-.54.54.24.54.54.54Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,22.32c.27,0,.49-.22.49-.49s-.22-.49-.49-.49-.49.22-.49.49.22.49.49.49Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,22.44c.33,0,.6-.27.6-.6s-.27-.6-.6-.6-.6.27-.6.6.27.6.6.6Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,22.53c.38,0,.7-.31.7-.7s-.31-.7-.7-.7-.7.31-.7.7.31.7.7.7Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,22.54c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,21.94c.06,0,.1-.05.1-.1s-.05-.1-.1-.1-.1.05-.1.1.05.1.1.1Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M35.06,21.86s.02-.01.02-.02,0-.02-.02-.02-.02,0-.02.02,0,.02.02.02Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,24.01s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,24.69c.42,0,.76-.34.76-.76s-.34-.76-.76-.76-.76.34-.76.76.34.76.76.76Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,24.58c.36,0,.65-.29.65-.65s-.29-.65-.65-.65-.65.29-.65.65.29.65.65.65Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,24.51c.32,0,.59-.26.59-.59s-.26-.59-.59-.59-.59.26-.59.59.26.59.59.59Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,24.53c.33,0,.6-.27.6-.6s-.27-.6-.6-.6-.6.27-.6.6.27.6.6.6Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,24.6c.37,0,.67-.3.67-.67s-.3-.67-.67-.67-.67.3-.67.67.3.67.67.67Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,24.44c.28,0,.51-.23.51-.51s-.23-.51-.51-.51-.51.23-.51.51.23.51.51.51Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,24.36c.24,0,.44-.19.44-.43s-.19-.44-.44-.44-.44.19-.44.44.19.43.44.43Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,24.44c.28,0,.51-.23.51-.51s-.23-.51-.51-.51-.51.23-.51.51.23.51.51.51Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.59,
    cy: 23.93,
    r: 0.59
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,24.61c.37,0,.68-.3.68-.68s-.3-.68-.68-.68-.68.3-.68.68.3.68.68.68Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.78,
    cy: 23.93,
    r: 0.73
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,24.57c.35,0,.64-.29.64-.64s-.29-.64-.64-.64-.64.29-.64.64.29.64.64.64Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,24.5c.32,0,.58-.26.58-.58s-.26-.58-.58-.58-.57.26-.57.58.26.58.57.58Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.06,
    cy: 23.93,
    r: 0.53
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,26.66c.36,0,.64-.29.64-.64s-.29-.64-.64-.64-.64.29-.64.64.29.64.64.64Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,26.1s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,26.66c.36,0,.64-.29.64-.64s-.29-.64-.64-.64-.64.29-.64.64.29.64.64.64Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,26.58c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,26.75c.4,0,.73-.33.73-.73s-.33-.73-.73-.73-.73.33-.73.73.33.73.73.73Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,26.62c.33,0,.6-.27.6-.6s-.27-.6-.6-.6-.6.27-.6.6.27.6.6.6Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,26.48c.26,0,.46-.21.46-.46s-.21-.46-.46-.46-.46.21-.46.46.21.46.46.46Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,26.52c.28,0,.5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,26.32c.17,0,.3-.13.3-.3s-.13-.3-.3-.3-.3.13-.3.3.13.3.3.3Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,26.28c.14,0,.26-.11.26-.26s-.11-.25-.26-.25-.26.11-.26.25.12.26.26.26Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,26.7c.37,0,.68-.3.68-.68s-.3-.68-.68-.68-.68.3-.68.68.3.68.68.68Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,26.47c.25,0,.45-.2.45-.45s-.2-.45-.45-.45-.45.2-.45.45.2.45.45.45Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,26.73c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,26.1s.08-.03.08-.08-.03-.08-.08-.08-.08.03-.08.08.03.08.08.08Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M37.15,26.04s.02-.01.02-.02-.01-.02-.02-.02c-.01,0-.02.01-.02.02s.01.02.02.02Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75,28.31c.11,0,.2-.09.2-.2s-.09-.2-.2-.2-.2.09-.2.2.09.2.2.2Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84,28.28c.09,0,.17-.08.17-.17s-.08-.17-.17-.17-.17.08-.17.17.08.17.17.17Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,28.34c.13,0,.23-.1.23-.23s-.1-.23-.23-.23-.23.1-.23.23.1.23.23.23Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,28.78c.37,0,.67-.3.67-.67s-.3-.67-.67-.67-.67.3-.67.67.3.67.67.67Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,28.8c.38,0,.68-.31.68-.68s-.31-.68-.68-.68-.69.31-.69.68.31.68.69.68Z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.22,
    cy: 28.11,
    r: 0.59
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,28.75c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,28.58c.26,0,.46-.21.46-.46s-.21-.46-.46-.46-.46.21-.46.46.21.46.46.46Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,28.37c.14,0,.25-.12.25-.26s-.11-.26-.25-.26-.26.12-.26.26.11.26.26.26Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,28.61c.27,0,.49-.22.49-.49s-.22-.49-.49-.49-.49.22-.49.49.22.49.49.49Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,28.68c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,28.67c.31,0,.55-.25.55-.55s-.25-.55-.55-.55-.55.25-.55.55.25.55.55.55Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,28.2s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.97,
    cy: 28.11,
    r: 0.53
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,30.28s.08-.03.08-.08-.03-.08-.08-.08-.08.03-.08.08.03.08.08.08Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,30.92c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,30.85c.36,0,.64-.29.64-.64s-.29-.64-.64-.64-.64.29-.64.64.29.64.64.64Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,30.77c.31,0,.56-.25.56-.56s-.25-.56-.56-.56-.56.25-.56.56.25.56.56.56Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,30.36c.08,0,.15-.07.15-.15s-.07-.15-.15-.15-.15.07-.15.15.07.15.15.15Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,30.63c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,30.44c.13,0,.23-.1.23-.23s-.1-.23-.23-.23-.23.1-.23.23.1.23.23.23Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,30.69c.27,0,.48-.22.48-.48s-.21-.48-.48-.48-.48.22-.48.48.22.48.48.48Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,30.35c.08,0,.14-.06.14-.14s-.06-.14-.14-.14-.14.06-.14.14.06.14.14.14Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,30.63c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M30.87,30.63c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M32.97,30.23s.02,0,.02-.02-.01-.02-.02-.02-.02.01-.02.02,0,.02.02.02Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94,32.47c.09,0,.17-.08.17-.17s-.08-.17-.17-.17-.17.08-.17.17.08.17.17.17Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,32.42c.07,0,.12-.05.12-.12s-.05-.12-.12-.12-.12.06-.12.12.05.12.12.12Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,32.71c.22,0,.41-.18.41-.41s-.18-.41-.41-.41-.41.18-.41.41.18.41.41.41Z"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.22,
    cy: 32.3,
    r: 0.72
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.31,
    cy: 32.3,
    r: 0.28
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.41,
    cy: 32.3,
    r: 0.14
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,32.93c.35,0,.63-.28.63-.63s-.28-.63-.63-.63-.63.28-.63.63.28.63.63.63Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,32.63c.18,0,.33-.14.33-.33s-.14-.33-.33-.33-.33.15-.33.33.15.33.33.33Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,32.62c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,32.62c.18,0,.32-.14.32-.32s-.14-.32-.32-.32-.32.14-.32.32.14.32.32.32Z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.87,
    cy: 32.3,
    r: 0.53
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.97,
    cy: 32.3,
    r: 0
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M12.03,34.42s.02,0,.02-.02,0-.02-.02-.02c-.01,0-.02.01-.02.02s0,.02.02.02Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,34.5c.06,0,.1-.05.1-.1s-.05-.11-.1-.11-.11.05-.11.11.05.1.11.1Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,34.68c.16,0,.28-.13.28-.28s-.13-.29-.28-.29-.28.13-.28.29.13.28.28.28Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M18.31,35.1c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M20.41,35.1c.39,0,.71-.32.71-.71s-.32-.71-.71-.71-.71.32-.71.71.32.71.71.71Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,34.62c.12,0,.22-.1.22-.22s-.1-.22-.22-.22-.22.1-.22.22.1.22.22.22Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,34.6c.11,0,.2-.09.2-.2s-.09-.2-.2-.2-.2.09-.2.2.09.2.2.2Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,34.6c.11,0,.2-.09.2-.2s-.09-.2-.2-.2-.2.09-.2.2.09.2.2.2Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,34.81c.23,0,.42-.19.42-.42s-.19-.42-.42-.42-.42.19-.42.42.19.42.42.42Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16.22,36.53s.04-.02.04-.04-.02-.04-.04-.04-.04.02-.04.04.02.04.04.04Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24.59,36.75c.14,0,.26-.12.26-.26s-.12-.26-.26-.26-.26.12-.26.26.12.26.26.26Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M26.69,36.52s.03-.01.03-.03c0-.02-.01-.03-.03-.03-.02,0-.03.01-.03.03,0,.02.01.03.03.03Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78,36.57s.08-.04.08-.08-.04-.08-.08-.08-.08.04-.08.08.04.08.08.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm25);
export default __webpack_public_path__ + "static/media/pm2.5.737618e7fa37b03e5126a7308d075da9.svg";
export { ForwardRef as ReactComponent };